export default __webpack_public_path__ + "static/media/division-6.e1eb19c9.png";